import React, { useCallback, useEffect, useState } from "react";
import {
  FaRegArrowAltCircleLeft,
  FaRegArrowAltCircleRight,
} from "react-icons/fa";
import PresentationReminderItem from "./PresentationReminderItem";
import { usePresentingSessionsTodayOrTomorrow } from "../api/selectors";
import useSessionId from "../sessions/useSessionId";
import LightTheme from "../theme/LightTheme";

const PresentationReminder = () => {
  const presentingSessions = usePresentingSessionsTodayOrTomorrow();
  const sessionId = useSessionId();

  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  useEffect(() => {
    setIsCollapsed(sessionId !== undefined);
  }, [sessionId]);

  const toggleCollapse = useCallback(() => {
    setIsCollapsed((oldValue) => !oldValue);
  }, []);

  if (presentingSessions.length === 0) {
    return null;
  }

  return (
    <div className="presenterUpcomingTagBlock">
      {isCollapsed ? (
        <div className="upcomingPresentationWrapper">
          <button
            type="button"
            className="collapse_button"
            onClick={toggleCollapse}
          >
            <FaRegArrowAltCircleRight
              size={20}
              color={LightTheme.font.secondary.color}
            />
          </button>
        </div>
      ) : (
        <div className="upcomingPresentationWrapper">
          <p className="upcomingText">
            You present at
            {presentingSessions.map((session, index) => (
              <PresentationReminderItem
                index={index}
                key={session.sessionId}
                lastIndex={presentingSessions.length - 1}
                session={session}
              />
            ))}
          </p>
          <button
            type="button"
            className="collapse_button"
            onClick={toggleCollapse}
          >
            <FaRegArrowAltCircleLeft
              size={20}
              color={LightTheme.font.secondary.color}
            />
          </button>
        </div>
      )}
      <style jsx>{`
        button {
          cursor: pointer;
        }
        .presenterUpcomingTagBlock {
          z-index: 9;
        }
        .upcomingPresentationWrapper {
          display: flex;
          flex-direction: row;
          height: 40px;
          position: absolute;
          background: #fdfefe;
          box-shadow: 2px 2px 10px rgba(166, 171, 189, 0.5);
          border-radius: 0 10px 10px 0;
          padding: 0 10px 0 60px;
          z-index: 1;
        }
        p {
          display: flex;
          align-items: center;
          color: ${LightTheme.font.secondary.color};
          font-weight: bold;
          font-size: 0.9rem;
        }
        .collapse_button {
          border: none;
          background: none;
        }
        .backArrowStyle {
          height: 15px;
          align-self: center;
          margin: 0 0 0 10px;
        }
        :global(.timeLink) {
          color: #3e93d3;
          margin: 0 3px;
          font-size: 0.9rem;
        }
      `}</style>
    </div>
  );
};

export default PresentationReminder;
